import { useVoiceDiagnostics, voiceExperiments } from '../lib/voiceDiagnostics'

/** Sichtbar mit `?debug` — siehe lib/voiceDiagnostics.ts, warum es das gibt. */
export function VoiceDiagnostics({ status }: { status: string }) {
  const d = useVoiceDiagnostics()
  const x = voiceExperiments()
  return (
    <pre className="w-full overflow-x-auto rounded-lg bg-bg-elevated p-2 text-left text-[11px] leading-snug text-text-muted">
      {`Status:        ${status}   gehalten: ${d.gehalten ? 'JA' : 'nein'}
Context:       ${d.context}
Formate:       ${d.formate}
Aufnahme:      ${d.aufnahme}
Echo weg:      ${d.echo}
Browser-AEC:   ${x.aecAn ? 'an (aec=1)' : 'aus'}
Unterläufe:    ${d.unterlaeufe}${Number.isFinite(d.vorlaufMinMs) ? ` (kleinster Vorlauf ${Math.round(d.vorlaufMinMs)} ms)` : ''}
Gesendet:      ${d.gesendetStimme} mit Stimme, ${d.gesendetStille} als Stille
Empfangen:     ${d.empfangenAudio} Audio, ${d.transkripte} Transkripte, ${d.antworten} Antworten
VAD max:       ${d.vadMax.toFixed(2)}
Letzte Nachr.: ${d.letzteNachricht}
Geschlossen:   ${d.geschlossen}
Kamera:        ${d.kameraBilder} Bilder, ${d.kameraAntworten} Antworten, stabil ${d.kameraStabil}
Kamera zuletzt:${d.kameraLetzte}
Dazwischen:    ${d.dazwischenVerdacht}× leiser, ${d.dazwischenGezaehlt}× erkannt, ${d.dazwischenFehlalarme}× Fehlalarm
Stichwort:     ${d.stichwortGeprueft}× geprüft, zuletzt ${d.stichwort}
Erkennung:     ${
        d.dazwischen
          ? `Mic ${d.dazwischen.mic.toFixed(3)} · sie ${d.dazwischen.aus.toFixed(3)} · Echo ×${d.dazwischen.echo.toFixed(2)} · Schwelle ${d.dazwischen.schwelle.toFixed(3)} · Verz. ${d.dazwischen.verzoegerung} · ×${d.dazwischen.nachschaerfung.toFixed(2)} · Stimme ${d.dazwischen.stimmPegel.toFixed(3)} · stimmhaft ${d.dazwischen.stimmhaft === null ? '—' : d.dazwischen.stimmhaft.toFixed(2)}`
          : '—'
      }
Build:         ${__K4IA_BUILD__}
Version:       ${__K4IA_VERSION__}`}
    </pre>
  )
}
